module.exports = __webpack_public_path__ + "static/media/guide_step2.dfdccfc1.png";